import tplSetupConvTodo from './src/template/setup-conversion-tracking-todo.pug';
import tplSetupConvPerformance from './src/template/performance-summary.pug';

export { RecommendationSetupConversionTrackingView } from './src/view/index';
export const templateSetupConvTodo = model => tplSetupConvTodo(model);
export const templateSetupConvPerformance = model => tplSetupConvPerformance(model);
